
import { JsonObject, JsonProperty } from 'json2typescript';
import { CaseWrite } from '../cases/case';
import { CaseClientLite } from '../cases/caseClient';
import { CaseOpponentLite } from '../cases/caseOpponent';
import { Court } from '../courts/court';
import { Expert } from './expert';
import { LawSuit } from './lawSuit';
import { LawyerSession } from './lawyerSession';

@JsonObject('ExpertSessionBase')
export class ExpertSessionBase {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('file_num', String, true)
    fileNum: string = null;

    @JsonProperty('notes', String, true)
    notes = null;

    @JsonProperty('case_sequence', Number, true)
    caseSequence: number = undefined;

    @JsonProperty('case_number', Number, true)
    number: number = undefined;

    @JsonProperty('sequence', Number, true)
    sequence: number = undefined;

    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    @JsonProperty('prev_session', String, true)
    prevSession = null;

    @JsonProperty('next_session', String, true)
    nextSession = null;

    @JsonProperty('lawyers', [LawyerSession], true)
    lawyers: LawyerSession[] = null;

    @JsonProperty('is_last_session', Boolean, true)
    lastSession: boolean = false;

    @JsonProperty('suits', [LawSuit], true)
    lawsuits: LawSuit[] = null;

    get getLawyersInitials() {
        return this.lawyers.map(l => l.lawyer?.initials).join(', ');
    }
    get getLawyers() {
        return this.lawyers.map(l => l.lawyer?.name).join(', ');
    }
    get getLawyersAr() {
        return this.lawyers.map(l => l.lawyer?.nameAr).join(', ');
    }

    //It is only used in create new session from file exert session page
    file: CaseWrite = null;
}

@JsonObject('ExpertSession')
export class ExpertSession extends ExpertSessionBase {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('expert', Expert)
    expert: Expert = null;

    @JsonProperty('court', Court, true)
    court: Court = null;

    @JsonProperty('clients', [CaseClientLite], true)
    clients: CaseClientLite[] = null;

    @JsonProperty('opponents', [CaseOpponentLite], true)
    opponents: CaseOpponentLite[] = null;

    @JsonProperty('last_session_date', String, true)
    lastSessionDate: string = null;

    @JsonProperty('next_session', String, true)
    nextSessionDate: string = null;

    @JsonProperty('created_date', String, true)
    createdDate: string = null;

    @JsonProperty('updated_date', String, true)
    updatedDate: string = null;

    get getCourt() {
        return this.court ? this.court.name : null;
    }
    get getCourtAr() {
        return this.court ? this.court.nameAr : null;
    }

    get getExpertName() {
        return this.expert ? this.expert.name : null;
    }

    get getExpertNameAr() {
        return this.expert ? this.expert.nameAr : null;
    }

    get getOpponents() {
        return this.opponents.map(l => l.opponent).join(', ');
    }

    get getNote() {
        return this.notes ? this.notes.noteStr : null;
    }
    get getLawsuits() {
        return this.lawsuits.map(l => l.claim).join(', ');
    }

    get sessionTime() {
        return new Date(this.nextSessionDate).getTime;
    }
}

@JsonObject('ExpertSessionWrite')
export class ExpertSessionWrite extends ExpertSessionBase {
    @JsonProperty('expert_id', Number, true)
    expertId: number = undefined;

    @JsonProperty('court_id', Number, true)
    courtId: number = null;

    init() {
        this.lawyers = [];
    }
}